// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const filterByValue = (
    array: any[],
    value: string,
    includes?: string[]
) => {
    const searchables = includes
        ? includes.map((include) => `searchable_${include}`)
        : undefined

    return array.filter((o) =>
        Object.keys(o).some((k) => {
            if (
                searchables &&
                searchables.length &&
                searchables.indexOf(k) === -1
            )
                return false

            if (
                typeof o[k] === 'string' &&
                o[k].toLowerCase().includes(value.toLowerCase())
            ) {
                return true
            }

            if (
                typeof o[k] === 'number' &&
                o[k].toString().includes(Math.abs(+value))
            ) {
                return true
            }

            return false
        })
    )
}
